import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import ContentHeading from '../../shared/commonComponents/ContentHeading';
import { Button, SelectDropdown, TextAreaInput, TextInput } from '../../shared/inputs';
import axios from "axios";

const ImportData = () => {

    const [method, setMethod] = useState("get");
    const [selectedUrl, setSelectedUrl] = useState(process.env.REACT_APP_IAMAPIURL);
    const [urlValue, setUrlValue] = useState("");
    const [finalUrl, setFinalUrl] = useState("");
    const [requestData, setRequestData] = useState();
    const [responseData, setResponseData] = useState();
    const userTokenData = useSelector((state) => state.auth.tokenData);


    const methodOptions = [
        { label: "GET", value: 'get' },
        { label: "POST", value: 'post' },
        { label: "PUT", value: 'put' },
        { label: "PATCH", value: 'patch' }
    ];

    const axiosUrls = [
        { label: "IAM Api", value: process.env.REACT_APP_IAMAPIURL },
        { label: "Configuration API", value: process.env.REACT_APP_CONFIGURATIONAPIURL },
        { label: "ProgramSetup API", value: process.env.REACT_APP_PROGRAMSETUPAPIURL },
        { label: "Onboarding API", value: process.env.REACT_APP_ONBOARDINGAPIURL },
        { label: "Network API", value: process.env.REACT_APP_NETWORKAPIURL },
        { label: "UserActivity API", value: process.env.REACT_APP_USERACTIVITYAPIURL },
    ];

    useEffect(() => {
        let url = selectedUrl + urlValue;
        setFinalUrl(url);
    }, [urlValue, selectedUrl]);

    const submitData = (event) => {
        event.preventDefault();

        axios({
            method,
            url: finalUrl,
            data: requestData,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userTokenData.accessToken
            }
        }).then(res => {
            setResponseData(res.data);
        });
    };

    return (
        <>

            <div className="import-data px-3 py-4 content-height d-flex flex-column">
                <ContentHeading title="Import Data" className="mb-3" />

                <div className="row">
                    <div className="form-group col-2 pr-0">
                        <SelectDropdown label="Method" className="pr-0" options={methodOptions} value={method} onChange={(v) => setMethod(v.target.value)} />
                    </div>
                    <div className="form-group col-2 px-0">
                        <SelectDropdown label="API" className="p-0" options={axiosUrls} value={selectedUrl} onChange={(v) => setSelectedUrl(v.target.value)} />
                    </div>
                    <div className="col pl-0" >
                        <TextInput label="URL" className="pl-0" value={urlValue} onChange={(e) => setUrlValue(e.target.value)} required />
                    </div>
                    <div className="cdx-input-info col-10 offset-2 pt-2">
                        {finalUrl}
                    </div>
                </div>

                <label className="px-2 pt-3 cdx-inpput-label">Response body</label>
                <div className="col-12 scroll-content">
                    <TextAreaInput rows="10" value={requestData} onChange={(e) => setRequestData(e.target.value)} />
                    <div className="d-flex justify-content-end">
                        <Button onClick={submitData}>Execute</Button>
                    </div>
                </div>
                <label className="px-2 cdx-inpput-label">Response body</label>
                <div className="px-2 scroll-content">

                    <div className="">
                        <pre>{JSON.stringify(responseData, null, 2)}</pre>

                    </div>
                </div>

            </div>
        </>
    );
};

export default ImportData;